module.exports = __webpack_public_path__ + "img/source02_02.abce127a.png";